module.exports = __webpack_public_path__ + "img/ico-check.151f575e.svg";